module.exports = __webpack_public_path__ + "static/media/vegitables_4.a54765f9.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_4.csv
// module id = 624
// module chunks = 0